import { render, staticRenderFns } from "./RecebimentoTransferencia.vue?vue&type=template&id=8b2b1078&"
import script from "./RecebimentoTransferencia.vue?vue&type=script&lang=js&"
export * from "./RecebimentoTransferencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports